import type React from 'react'

interface CreateVideoIconProps {
	size?: number
	className?: string
	style?: React.CSSProperties
}

export function CreateVideoIcon({ size = 20, className, style }: CreateVideoIconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			className={className}
			style={{ flexShrink: 0, ...style }}
		>
			<path
				d="M15.1708 4.82363L13.7084 5.38807C13.6058 5.41373 13.5289 5.54201 13.5289 5.64463C13.5289 5.77291 13.6058 5.90119 13.7084 5.92685L15.1708 6.46563L15.7096 7.92803C15.7353 8.03065 15.8636 8.10762 15.9918 8.10762C16.0945 8.10762 16.2228 8.03065 16.2484 7.92803L16.8128 6.46563L18.2496 5.92685C18.3779 5.90119 18.4548 5.77291 18.4548 5.64463C18.4548 5.54201 18.3779 5.41373 18.2496 5.38807L16.8128 4.82363L16.2484 3.38689C16.2228 3.25861 16.0945 3.18164 15.9918 3.18164C15.8636 3.18164 15.7353 3.25861 15.7096 3.38689L15.1708 4.82363Z"
				fill="currentColor"
			/>
			<path
				d="M2.45459 14.6302V6.48306C2.45459 5.62598 3.23085 4.93164 4.18903 4.93164H11.5341C11.7826 4.93164 11.9834 5.11132 11.9834 5.33353C11.9834 5.55573 11.7826 5.73541 11.5341 5.73541H4.18903C3.72768 5.73541 3.35318 6.07039 3.35318 6.48306V14.6302C3.35318 15.0429 3.72768 15.3779 4.18903 15.3779H16.7202C17.1815 15.3779 17.556 15.0429 17.556 14.6302V9.4771C17.556 9.25489 17.7569 9.07521 18.0053 9.07521C18.2537 9.07521 18.4546 9.25489 18.4546 9.4771V14.6302C18.4546 15.4873 17.6783 16.1816 16.7202 16.1816H4.18903C3.23085 16.1816 2.45459 15.4873 2.45459 14.6302Z"
				fill="currentColor"
			/>
			<path
				d="M8.98663 13.1163C9.08613 13.1249 9.18562 13.0989 9.28512 13.0382L12.9838 10.8524C13.0746 10.796 13.133 10.7245 13.159 10.6377C13.1893 10.5467 13.1893 10.4578 13.159 10.371C13.1287 10.2799 13.0703 10.2084 12.9838 10.1563L9.28512 7.95754C9.19427 7.90549 9.09694 7.88381 8.99312 7.89248C8.89362 7.89682 8.80927 7.92935 8.74005 7.99006C8.67084 8.05078 8.63623 8.13318 8.63623 8.23727V12.7585C8.63623 12.8626 8.66867 12.9471 8.73356 13.0122C8.80278 13.0729 8.88713 13.1076 8.98663 13.1163Z"
				fill="currentColor"
			/>
		</svg>
	)
}
